import React, { useState, useEffect, useRef } from 'react';
// import backgroundImage from '@/images/experiences.jpg';
import backgroundImage from '@/images/exp.webp';

interface TimelineItem {
  year: string;
  title: string;
  description: string;
  companyname: string;
}

const experiences: TimelineItem[] = [
  { year: '2025 April - Present', title: 'UI/UX Engineer', companyname: 'H2Compute pvt(ltd)', description: 'Created digital experiences for various clients across multiple industries.' },
  { year: '2023 August - 2025 March', title: 'Associate UI/UX Engineer', companyname: 'H2Compute pvt(ltd)', description: 'Created digital experiences for various clients across multiple industries.' },
  { year: '2022 Dec - 2023 June', title: 'UI/UX Engineer (Intern)', companyname: 'Infinity Innovators', description: 'Designed mobile applications from concept to launch, working closely with development teams.' },
  { year: '2021 Jan - 2021 July', title: 'Software Engineer (Intern)', companyname: 'Axsys Solutions', description: 'Developed visual design for web platforms and mobile applications.' },
];

const skills: string[] = [
  'User Research', 'Wireframing', 'Prototyping', 'UI Design',
  'Interaction Design', 'Design Systems', 'User Testing', 'Figma',
  'Adobe XD', 'Sketch', 'HTML/CSS', 'JavaScript',
];

const Experiences = () => {
  const [activeTab, setActiveTab] = useState<'experience' | 'skills'>('experience');
  const [visibleItems, setVisibleItems] = useState<number[]>([]);
  const timelineRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      const sequence = activeTab === 'experience'
        ? experiences.map((_, index) => index)
        : skills.map((_, index) => index);
      setVisibleItems(sequence);
    }, 300);
    return () => clearTimeout(timer);
  }, [activeTab]);

  return (
    <section id="experiences" className="relative text-white bg-cover bg-center bg-fixed pb-20" style={{ backgroundImage: `url(${backgroundImage})` }}>
      {/* Background overlay */}
      <div className="absolute inset-0 bg-black/30 z-0"></div>

      {/* Foreground content */}
      <div className="relative z-10 container mx-auto  px-4 bg-transparent">
      <h5 className=' text-primary mb-6 font-Urbanist font-medium tracking-widest text-xl'>Experiences</h5>
        <h2 className="section-heading font-Urbanist font-light tracking-widest sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl">
        Wohooo, This Is The Path I’ve Walked😎
        </h2>
        <div className="flex space-x-2 mb-8 bg-[rgba(0,0,0,0.27)] backdrop-blur-md border border-white/30 shadow-md p-8 rounded-lg sm:w-3/5 mx-auto w-[unset]">
        {activeTab === 'experience' && (
          <div ref={timelineRef} className="relative border-l-2 border-neutral-200">
            {experiences.map((item, index) => (
              <div
                key={index}
                className={`relative pl-8 mb-8 transition-all duration-500 ease-out ${visibleItems.includes(index) ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${index * 150}ms` }}
              >
                <div className="absolute left-[-0.4rem] top-[15%] w-3 h-3 rounded-full bg-white z-10"></div>
                <span className="text-sm font-medium text-white">{item.year}</span>
                <h3 className="text-xl font-medium">{item.title}</h3>
                <span className="text-sm font-medium text-white">{item.companyname}</span>
                <p className="text-white">{item.description}</p>
              </div>
            ))}
          </div>
        )}

        {activeTab === 'skills' && (
          <div className="grid grid-cols-2 gap-3">
            {skills.map((skill, index) => (
              <div
                key={index}
                className={`bg-white p-3 rounded-lg shadow-sm border border-neutral-200 transition-all duration-500 ease-out ${visibleItems.includes(index) ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${index * 80}ms` }}
              >
                {skill}
              </div>
            ))}
          </div>
        )}
        </div>


        
      </div>
    </section>
  );
};

export default Experiences;
